import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // 1. Import this
import App from './App';
import { NotificationProvider } from './contexts/NotificationContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
    <BrowserRouter> {/* 2. Wrap your App here */}
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </BrowserRouter>
  // </React.StrictMode>
);